module.exports = __webpack_public_path__ + "static/img/cangzhouwei1.64ea6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cangzhouwei1.png
// module id = evmS
// module chunks = 1